import {Injectable} from '@angular/core'
import {Observable} from 'rxjs'

import {GenericManagerService} from '@app/core/services/generic-manager.service'

import {
  DomainService,
  Domain,
  DataMap,
  CreateDomainRequestData,
} from '@app/core/services/domain/domain.service'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'

@Injectable()
export class DomainDataManagerService extends GenericManagerService<Domain> {
  constructor(
    private domainSvc: DomainService,
    protected notify: NotificationService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(id: any): Observable<Domain> {
    return this.domainSvc.getDomain(id)
  }

  retrieveId(domain: Domain): any {
    return domain.code
  }

  doUpdate(id: any, domain: Domain): Observable<Domain> {
    return this.domainSvc.putDomain(id, domain)
  }

  doCreate(data: CreateDomainRequestData): Observable<Domain> {
    return this.domainSvc.postDomain(data)
  }

  doDelete(id: any): Observable<void> {
    return this.domainSvc.deleteDomain(id)
  }

  updateAttributes(attributes: DataMap): Observable<DataMap> {
    return this.domainSvc.putAttributes(this.id, attributes)
  }

  updateData(data: DataMap): Observable<DataMap> {
    return this.domainSvc.putData(this.id, data)
  }
}
